
import {apolloClient} from '@/setup/apollo-setup'

import {
    GET_DASHBOARD_BORROWER_COUNT,
    GET_DASHBOARD_LOAN_AMOUNT,
    GET_DASHBOARD_OUTSTANDING_AMOUNT,
    GET_DASHBOARD_PROSECUTION_COUNT,
    GET_DASHBOARD_LOAN_SPENDING,
    GET_DASHBOARD_PAYMENT_DUE,
    GET_DASHBOARD_DEBT_TRACKING,
    GET_DASHBOARD_STAGE_AGINGS,
    GET_DASHBOARD_BORROWERS,
    GET_DASHBOARD_LOAN_AMOUNT_BORROWERS,
    GET_DASHBOARD_OUTSTANDING_REMAIN_BORROWERS,
     GET_DASHBOARD_PROSECUTION_BORROWERS,
    GET_DASHBOARD_LOAN_SPENDING_BORROWERS,
    GET_DASHBOARD_PAYMENT_DUE_BORROWERS,
    GET_DASHBOARD_STAGE_AGING_NORMAL_BORROWERS,
    GET_DASHBOARD_STAGE_AGING_ALL_BORROWERS,
    GET_DASHBOARD_STAGE_AGING_1_BORROWERS,
    GET_DASHBOARD_STAGE_AGING_2_BORROWERS,
    GET_DASHBOARD_STAGE_AGING_3_BORROWERS,
  GET_DASHBOARD_FOLLOW_UP_BORROWERS,
  GET_DASHBOARD_MONTHLY_PAYMENT_HISTORIES
} from '@/queries/modules/dashboard'

import {
    error,
} from '@/utils/notification'

export async function getDashboardBorrowerCount(context) {
    // console.log('Get Dashboard Borrower Count...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_BORROWER_COUNT,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardBorrowerCount} = data

        context.commit('setDashboardBorrowerCount', dashboardBorrowerCount)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardLoanAmount(context) {
    // console.log('Get Dashboard Loan Amount...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_LOAN_AMOUNT,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardLoanAmount} = data

        context.commit('setDashboardLoanAmount', dashboardLoanAmount)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardOutstandingAmount(context) {
    // console.log('Get Dashboard Outstanding...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_OUTSTANDING_AMOUNT,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardOutstandingAmount} = data

        context.commit('setDashboardOutstandingAmount', dashboardOutstandingAmount)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardProsecutionCount(context) {
    // console.log('Get Dashboard Prosecution Count...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_PROSECUTION_COUNT,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardProsecutionCount} = data

        context.commit('setDashboardProsecutionCount', dashboardProsecutionCount)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardLoanSpending(context) {
    // console.log('Get Dashboard Loan Spending...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_LOAN_SPENDING,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardLoanSpending} = data

        context.commit('setDashboardLoanSpending', dashboardLoanSpending)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardPaymentDue(context) {
    // console.log('Get Dashboard Payment Due...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_PAYMENT_DUE,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardPaymentDue} = data

        context.commit('setDashboardPaymentDue', dashboardPaymentDue)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardDebtTracking(context) {
    // console.log('Get Dashboard Debt Tracking...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_DEBT_TRACKING,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardDebtTracking} = data

        context.commit('setDashboardDebtTracking', dashboardDebtTracking)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardStageAgings(context) {
    // console.log('Get Dashboard Stage Agings...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_STAGE_AGINGS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardStageAgings} = data

        context.commit('setDashboardStageAgings', dashboardStageAgings)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardBorrowers(context) {
    // console.log('Get Dashboard Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardBorrowers} = data
        // console.log('dashboardBorrowers', dashboardBorrowers)
        context.commit('setDashboardBorrowers', dashboardBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardLoanAmountBorrowers(context) {
    // console.log('Get Dashboard Loan Amount Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_LOAN_AMOUNT_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardLoanAmountBorrowers} = data

        context.commit('setDashboardLoanAmountBorrowers', dashboardLoanAmountBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardOutstandingRemainBorrowers(context) {
    // console.log('Get Dashboard Outstanding Remain Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_OUTSTANDING_REMAIN_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardOutstandingRemainBorrowers} = data

        context.commit('setDashboardOutstandingRemainBorrowers', dashboardOutstandingRemainBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardProsecutionBorrowers(context) {
    // console.log('Get Dashboard Prosecution Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_PROSECUTION_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardProsecutionBorrowers} = data

        context.commit('setDashboardProsecutionBorrowers', dashboardProsecutionBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }

}

export async function getDashboardLoanSpendingBorrowers(context) {
    // console.log('Get Dashboard Loan Spending Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_LOAN_SPENDING_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardLoanSpendingBorrowers} = data

        context.commit('setDashboardLoanSpendingBorrowers', dashboardLoanSpendingBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardPaymentDueBorrowers(context) {
    // console.log('Get Dashboard Payment Due Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_PAYMENT_DUE_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardPaymentDueBorrowers} = data

        context.commit('setDashboardPaymentDueBorrowers', dashboardPaymentDueBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardStageAgingNormalBorrowers(context) {
    // console.log('Get Dashboard Stage Aging Normal Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_STAGE_AGING_NORMAL_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardStageAgingNormalBorrowers} = data

        context.commit('setDashboardStageAgingNormalBorrowers', dashboardStageAgingNormalBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardStageAgingAllBorrowers(context) {
    // console.log('Get Dashboard Stage Aging All Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_STAGE_AGING_ALL_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardStageAgingAllBorrowers} = data
        // console.log('dashboardStageAgingAllBorrowers', dashboardStageAgingAllBorrowers)

        context.commit('setDashboardStageAgingAllBorrowers', dashboardStageAgingAllBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardStageAging1Borrowers(context) {
    // console.log('Get Dashboard Stage Aging 1 Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_STAGE_AGING_1_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardStageAging1Borrowers} = data

        context.commit('setDashboardStageAging1Borrowers', dashboardStageAging1Borrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardStageAging2Borrowers(context) {
    // console.log('Get Dashboard Stage Aging 2 Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_STAGE_AGING_2_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardStageAging2Borrowers} = data

        context.commit('setDashboardStageAging2Borrowers', dashboardStageAging2Borrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardStageAging3Borrowers(context) {
    // console.log('Get Dashboard Stage Aging 3 Borrowers...')
    try {
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_STAGE_AGING_3_BORROWERS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardStageAging3Borrowers} = data

        context.commit('setDashboardStageAging3Borrowers', dashboardStageAging3Borrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardFollowUpBorrowers(context, payload) {
    // console.log('Get Dashboard Follow Up Borrowers...')
    try {

      const variables = { id: payload.id }
        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_FOLLOW_UP_BORROWERS,
                variables,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {dashboardFollowUpBorrowers} = data
      // console.log('dashboardFollowUpBorrowers', dashboardFollowUpBorrowers)

        context.commit('setDashboardFollowUpBorrowers', dashboardFollowUpBorrowers)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getDashboardMonthlyPaymentHistories(context, payload) {
    // console.log('Get Dashboard Monthly Payment Histories...')
    try {

      const variables = { year: payload.year }

        const response = await apolloClient
            .query({
                query: GET_DASHBOARD_MONTHLY_PAYMENT_HISTORIES,
                fetchPolicy: 'network-only',
              variables,
            })

        const {data} = await response
        const {dashboardMonthlyPaymentHistories} = data
      // console.log('dashboardMonthlyPaymentHistories', dashboardMonthlyPaymentHistories)

        context.commit('setDashboardMonthlyPaymentHistories', dashboardMonthlyPaymentHistories)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}
